export default class ProcedureCode {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "";
  }

  getProcedureCodeList(search, searchType) {
    return this.client.get(`/procedurecodes`, {
      params: { search, searchType },
    });
  }

  getProcedureDescriptions(codes) {
    return this.client.post(`/master/getProcCodeDescriptions`, codes);
  }
  getCodeGroupProcedureCodeList(healthPlanKey, status) {
    return this.client.get(`/code-group/procedure`, {
      params: { healthPlanKey, status },
    });
  }
}
